// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * MySQL数据类型枚举 枚举类
 * MySQL数据类型枚举
 */
export enum EnumMySQLDataType {
  /** 单字节整数 : 单字节整数，1个字节 */
  Tinyint = 1,
  /** 短整数 : 双字节整数，2个字节 */
  Smallint = 2,
  /** 三字节整数 : 三字节整数，三个字节 */
  Mediumint = 4,
  /** 整数 : 整数，四个字节 */
  Int = 8,
  /** 长整数 : 长整数，八个字节 */
  Bigint = 16,
  /** 定长字符串 : 固定长度字符串，不超过255个字节 */
  Char = 32,
  /** 变长字符串 : 变长字符串，不超过255个字节 */
  Varchar = 64,
  /** 长文本 : 长文本，不超过65535个字节 */
  Text = 128,
  /** 单精度浮点数 : 单精度浮点数，4个字节 */
  Float = 256,
  /** 双精度浮点数 : 双精度浮点数，8个字节 */
  Double = 512,
  /** 小数 : 小数 */
  Decimal = 1024,
  /** 布尔型 : 使用1个bit位 */
  Bit = 2048,
  /** 日期时间型 : 日期时间型，8个字节，最小日期为1000-01-01 */
  DateTime = 4096
}

/**
 * MySQL数据类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumMySQLDataTypeMD {
  private static items = [
    new EnumItemMD('Tinyint', 1, '单字节整数', '单字节整数，1个字节'),
    new EnumItemMD('Smallint', 2, '短整数', '双字节整数，2个字节'),
    new EnumItemMD('Mediumint', 4, '三字节整数', '三字节整数，三个字节'),
    new EnumItemMD('Int', 8, '整数', '整数，四个字节'),
    new EnumItemMD('Bigint', 16, '长整数', '长整数，八个字节'),
    new EnumItemMD('Char', 32, '定长字符串', '固定长度字符串，不超过255个字节'),
    new EnumItemMD('Varchar', 64, '变长字符串', '变长字符串，不超过255个字节'),
    new EnumItemMD('Text', 128, '长文本', '长文本，不超过65535个字节'),
    new EnumItemMD('Float', 256, '单精度浮点数', '单精度浮点数，4个字节'),
    new EnumItemMD('Double', 512, '双精度浮点数', '双精度浮点数，8个字节'),
    new EnumItemMD('Decimal', 1024, '小数', '小数'),
    new EnumItemMD('Bit', 2048, '布尔型', '使用1个bit位'),
    new EnumItemMD('DateTime', 4096, '日期时间型', '日期时间型，8个字节，最小日期为1000-01-01')
  ];

  static getItem(enumItem: EnumMySQLDataType) {
    return this.items.find(item => item.name === EnumMySQLDataType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
